module.exports = __webpack_public_path__ + "img/Drink Icon - white.c36f12ee.svg";